import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';

import { BlahModule } from '@headpower/blah-ng';

import { MapComponent } from './map/map.component';
import { StatusScreenComponent } from './status-screen/status-screen.component';

import { MapService } from './map/map.service';
import { MapLayerService } from './map/map-layer.service';
import { ObservationModule } from '../modules/observation/observation.module';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SpinnerModule } from '@headpower/components';

@NgModule({
    declarations: [
        MapComponent,
        StatusScreenComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        MatTableModule,
        BlahModule,
        ObservationModule,
        RouterModule,
        MatTooltipModule,
        SpinnerModule
    ],
    exports: [
        MapComponent,
        StatusScreenComponent,
    ],
    bootstrap: [],
    providers: [
        MapService,
        MapLayerService,
    ]
})
export class MapModule { }
